var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2521 5.79574L14.2806 3.16706C13.7496 2.45912 12.7581 2.28928 12.0218 2.78015L7.43994 5.83472",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2512 9.58301H18.3354C18.7958 9.58301 19.1691 9.95626 19.1691 10.4167V12.9177C19.1691 13.3782 18.7958 13.7514 18.3354 13.7514H16.2512C15.1001 13.7514 14.167 12.8183 14.167 11.6672V11.6672C14.167 10.5161 15.1001 9.58301 16.2512 9.58301V9.58301Z",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3363 9.58457V7.91721C18.3363 6.76614 17.4032 5.83301 16.2521 5.83301H5.41428C4.26321 5.83301 3.33008 6.76614 3.33008 7.91721V15.4203C3.33008 16.5714 4.26321 17.5045 5.41428 17.5045H16.2521C17.4032 17.5045 18.3363 16.5714 18.3363 15.4203V13.753",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.dd0ac032d7fcb69df41fb6b9ab261f42.svg";
export { ForwardRef as ReactComponent };